export class QuickOrderPositionDto {
	public position: number = 0;
	public description: string = "";
	public quantity: number = 0;
	public unit: string = "";
	public pricePerUnit: number = 0;
}
